var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"header-border px-5 py-2"},[_c('div',{staticClass:"d-flex"},[_c('h3',{staticClass:"text-subtitle-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-spacer'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }